import './condition';

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-template-loop-filters' )
export class AutomatorTemplateItemLoopFilters extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	/**
	 * The loop filters used within the loop block.
	 * Each filter contains relevant properties such as `integration_code`, `title`, and `title_html`.
	 *
	 * @type {Array<Object>}
	 * @property {Array<Object>} loopFilters - The list of filters for the loop block.
	 * Attribute name in HTML: none (non-reflected property).
	 */
	@property( { type: Array, attribute: false } )
	accessor loopFilters;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="conditions">
				${ repeat(
					this.loopFilters,
					( condition, index ) => index,
					condition => html`
						<uap-template-loop-filter-condition
							integration-code=${ condition.integration_code }
							.title=${ condition.title }
							.titleHTML=${ condition.title_html }
						></uap-template-loop-filter-condition>
					`
				) }
			</div>
		`;
	}
}